<template>
  <div>
    <Breadcrumbs main="Menüler" title="Liste" :links="breadLinks" />

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <label class="sr-only" for="inline-form-input-name">Tip</label>
              <b-form-select
                id="filtre_tipi"
                v-model="filtre_tipi"
                :options="filtre_tipler"
                @change="onFiltreTipChange"
                class="mb-2 mr-sm-2 mb-sm-0"
              ></b-form-select>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <c-table :tablefields="tablefields" :items="items">
                <template #cell(Islem)="row">
                  <b-btn-group>
                    <router-link
                      :to="`/menu/kayit/${row.item.Id}`"
                      class="btn btn-success btn-xs"
                      >Düzelt</router-link
                    >
                    <b-button size="xs" @click="sil(row.item)" variant="danger"
                      >Sil</b-button
                    >
                  </b-btn-group>
                </template>
                <template #cell(Aktif)="data">
                  <c-aktif-cell :isAktif="data.value"></c-aktif-cell>
                </template>
                <template #cell(KayitTarihi)="row">
                  <c-tarih-cell
                    :kayitTarihi="row.item.KayitTarihi"
                    :guncelTarih="row.item.GuncelTarih"
                    :rowKey="row.item.Id"
                  ></c-tarih-cell>
                </template>
              </c-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      breadLinks: [{ path: "/menu/kayit", title: "Ekle", icon: "plus" }],
      tablefields: [
        { key: "Islem", label: "İşlemler", sortable: false },
        { key: "TipiStr", label: "Tipi", sortable: true },
        { key: "Tanim", label: "Menü Adı", sortable: true },
        { key: "Link", label: "Link", sortable: true },
        { key: "Aktif", label: "Aktif", sortable: true },
        { key: "Sira", label: "Sira", sortable: true },
        { key: "KullaniciAdi", label: "Kullanıcı", sortable: true },
        { key: "KayitTarihi", label: "Kayıt Tarihi", sortable: true },
      ],

      items: [],

      filtre_tipi: 1,
      filtre_tipler: [],
    };
  },
  mounted() {
    this.onTipler();
    this.onList();
  },
  methods: {
    onTipler() {
      let vm = this;

      this.$connection.get("/menuler/MenuTipleri", function (response) {
        vm.filtre_tipler = response;
      });
    },
    onFiltreTipChange() {
      this.onList();
    },
    onList() {
      let vm = this;

      this.$connection.get(
        "/menuler/all/" + vm.filtre_tipi,
        function (response) {
          vm.items = response;
        }
      );
    },
    sil(item) {
      let vm = this;
      this.$alert.confirm(
        "Sil",
        "Menü kaydını silmek istediğinize emin misiniz?",
        "warning",
        function () {
          vm.$connection.delete("/menuler/" + item.Id, function (response) {
            vm.$alert.messageWithFunction(
              "Silindi",
              "Menü kaydı silindi.",
              "error",
              function () {
                vm.$listHelper.removeItem(vm.items, item);
              }
            );
          });
        }
      );
    },
  },
};
</script>
